//判断是否是移动端
export function isMobile() {
	if (navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
	) {
		console.log("手机端");
		return true; // 手机端
	} else {
		console.log("PC端");
		return false; // alert('PC端')
	}
}

/** 克隆对象
 * @param {Object} obj
**/
export const cloneObj = function (obj) {
	let o;
	if (typeof obj === "object") {
		if (obj === null) {
			o = null;
		} else {
			if (obj instanceof Array) {
				o = [];
				for (var i = 0, len = obj.length; i < len; i++) {
					o.push(cloneObj(obj[i]));
				}
			} else {
				o = {};
				for (var j in obj) {
					o[j] = cloneObj(obj[j]);
				}
			}
		}
	} else {
		o = obj;
	}
	return o;
};

/** 对象多层嵌套获取val值
 * @param {Object} obj
**/
export const setObjVal = (obj, keys, newV) => {
	return keys.split(".").reduce((o, k, i, arr) => {
		if (i == arr.length - 1) {
			o[k] = newV;
		}
		if (k.indexOf("[") == 0 && k.lastIndexOf("]") == k.length - 1) {
			let num = Number(k.slice(1).slice(0, k.length - 2));
			return o[num];
		} else {
			return o[k];
		}
	}, obj);
};

/** 是否空对象
 * @param {Object} obj 
**/
export const isEmptyObject = (obj) => {
	let name;
	for (name in obj) {
		return false;
	}
	return true;
}

/** 下载文件流
 * @param {String} res 文件流
 * @param {String} title 文件下载标题
**/
export const downloadBlob = (res, title) => {
	let blob = new Blob([res],{type:'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
	let link = document.createElement("a");
	link.href = URL.createObjectURL( blob ); 
	link.download = title || "SN库存列表";
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link)
}

/** 多维对象数组拍平
 * @param {Array} data 多维对象数组
 * @return {Array} result 一维数组
**/
export const objectArrayFlat = (data, childName = "children") => {
	let result = [];
	let queue = data;
	while (queue.length > 0) {
		[...queue].forEach(child => {
				queue.shift();
				result.push(child);
				if(child[childName]) {
					queue.push(...child[childName])
					delete child[childName]
				}
		});
	}
	return result;
}

/** 一维对象数组生成树结构
 * @param {Array} nodeList 一维数组
 * @return {Array} result 多维对象数组
**/
export const generateTree = (nodeList, menu_id = "menu_id", parent_id = "parent_id") => {
	const nodeMap = nodeList.reduce((acc, cur) => { 
		acc[cur[menu_id]] = cur
		return acc
	}, {});
	const res = [];
	nodeList.forEach(node => {
		if (node[parent_id] == 0) {
			res.push(node);
			return
		}
		const parentNode = nodeMap[node[parent_id]];
		parentNode.children= [...(parentNode.children || []), node] ;
	});
	return res;
}

// 权限判断
export const checkPermission = (array, per) => {
  if (!array || !per) return false;
  return array.indexOf(per) > -1;
};

/**
 * 根据分页获取数据
 * @param { Array } datalist
 * @param { Object } pageParams
 */
 export const getDataByPage = (datalist, pageParams) => {
  if (
    !datalist ||
    (datalist && datalist.length === 0) ||
    !Array.isArray(datalist)
  ) {
    return [];
  }
  if (!pageParams) {
    return datalist;
  }
  if (!pageParams.current) {
    pageParams.current = 1;
  }
  if (!pageParams.size) {
    pageParams.size = 30;
  }

  return datalist.slice(
    (pageParams.current - 1) * pageParams.size,
    pageParams.current * pageParams.size
  );
};

/** 
 * 格式化日期时间
**/
export const formatDateTime =  (d) =>  {
	if(!d) return ""; 
	var date = new Date(d);
	var YY = date.getFullYear() + '-';
	var MM =
		(date.getMonth() + 1 < 10
			? '0' + (date.getMonth() + 1)
			: date.getMonth() + 1) + '-';
	var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	var hh =
		(date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var mm =
		(date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
		':';
	var ss =
		date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	return YY + MM + DD + ' ' + hh + mm + ss;
};

/** 
 * 格式化日期
**/
export const formatDate =  (d, type) =>  {
	if(!d) return ""; 
	var date = new Date(d);
	var YY = date.getFullYear() + '-';
	var MM =
		(date.getMonth() + 1 < 10
			? '0' + (date.getMonth() + 1)
			: date.getMonth() + 1) + '-';
	var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	var time = type == "start" ? "00:00:00" : "23:59:59";
	return YY + MM + DD + ' ' + time;
};

 
/** 排序函数
 * @param {Array} objArr 排序的对象数组
 * @param {Array} key 需要排序的对象的key
 * @param {Array} type 排序类型 localeCompare， sort
 * @return {Array} result 排序后的对象数组
**/
export const objArraySort = (objArr, key, type = "localeCompare") => {
	let result = objArr.slice(0);
	if(type == "localeCompare") {
		return result.sort((a, b)=>{
			return (a[key].toUpperCase()).localeCompare(b[key].toUpperCase())
		}) 
	} else if(type == "sort"){
		return result.sort((a, b) => b[key] - a[key]);
	}
}